// Author Eric
// Date 2020-09-18 09:17:41

class SithMesAndonLightLevel {
constructor({
        id = null,
        name = '',
        level = '',
        colorValue = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.level = level;
    this.colorValue = colorValue;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesAndonLightLevel();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonLightLevel.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.andon.sithMesAndonLightLevel.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'colorValue',
        label: 'label.sith.andon.sithMesAndonLightLevel.grid.colorValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonLightLevel.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    levelFilter : "",
    colorValueFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.andon.sithMesAndonLightLevel.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.sith.andon.sithMesAndonLightLevel.filter.level',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'colorValueFilter',
        label: 'label.sith.andon.sithMesAndonLightLevel.filter.colorValue',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonLightLevel.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'level',
        label: 'label.sith.andon.sithMesAndonLightLevel.entity.level',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'colorValue',
        label: 'label.sith.andon.sithMesAndonLightLevel.entity.colorValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonLightLevel.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesAndonLightLevel, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
